function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "stroke",
  d: "M29.9,38.4l.315-3.547h4.572L34.193,38.4ZM11.532,34.857H16.1l.315,3.547H12.163ZM15.276,24.61l.315,3.547h-5.2L9.8,24.61Zm7.606-7.527a.37.37,0,0,1,.276-.118.328.328,0,0,1,.276.118L28.6,22.206H17.719Zm7.724,12.651h5.044L35.06,33.28H30.331Zm-6.66,3.547V29.733H29.03l-.315,3.547Zm0,1.576H28.6L28.281,38.4H23.946Zm-1.576,0V38.4H18l-.315-3.547Zm0-6.7h-5.2l-.315-3.547H22.37Zm1.576-3.547h5.517l-.315,3.547h-5.2Zm-7.961,8.67H11.256l-.591-3.547H15.71Zm1.3-3.547H22.37V33.28H17.562Zm18.641-1.576H30.764l.315-3.547h5.478Zm-4.02-5.911h0l-6.778-6.818a2.806,2.806,0,0,0-1.97-.828,2.564,2.564,0,0,0-1.931.828l-6.778,6.778-.039.039H7L9.916,39.468a1.564,1.564,0,0,0,1.537,1.3H34.784a1.564,1.564,0,0,0,1.537-1.3l3-17.222Z",
  transform: "translate(-4.241 -8.881)",
  fill: "#f5f5f5"
}));

function SvgCesta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "2 5 34 34.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCesta);
export default __webpack_public_path__ + "static/media/cesta.259fcc19.svg";
export { ForwardRef as ReactComponent };